export const BenefitsData = [
  {
    title: "increase_revenue",
    description: "increase_revenue_text",
  },
  {
    title: "improve_customer",
    description: "improve_customer_text",
  },
  {
    title: "turn_tables",
    description: "turn_tables_text",
  },
  {
    title: "seamless_experience",
    description: "seamless_experience_text",
  },
  {
    title: "improve_ordering",
    description: "improve_ordering_text",
  },
  {
    title: "decrease_cost",
    description: "decrease_cost_text",
  },
  {
    title: "access_to_data",
    description: "access_to_data_text",
  },
]
